import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

// ── FETCH LISTE ──────────────────────────────────────────────────────────────
// L'event REFRESH doit être émis avec le service actif: { service: '1bpay' }
bus.on(constants.EVENTS.BLACKLIST.LIST_ALL.REFRESH, ({ service } = {}) => {
  if (!service) return;
  const requestId = `listAllBlacklist-${Date.now()}`;
  bus.emit(constants.EVENTS.BLACKLIST.LIST_ALL.REFRESHING);
  const url = constants.ENDPOINTS.BLACKLIST.GET_LIST.replace('{service}', service);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id !== requestId) return;
    bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
    const parsed = serializer.deserializeList(res);
    if (parsed.success) {
      bus.emit(constants.EVENTS.BLACKLIST.LIST_ALL.REFRESHED, parsed.data);
    } else {
      bus.emit(constants.EVENTS.BLACKLIST.LIST_ALL.REFRESH_ERROR, parsed);
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});

// ── AJOUTER À LA BLACKLIST ───────────────────────────────────────────────────
bus.on(constants.EVENTS.BLACKLIST.ADD.SUBMIT, ({ playerId, service, currency }) => {
  const requestId = `addBlacklist-${Date.now()}`;
  bus.emit(constants.EVENTS.LOADING.START);

  const url = constants.ENDPOINTS.BLACKLIST.ADD
    .replace('{playerId}', playerId)
    .replace('{service}', service)
    .replace('{currency}', currency);

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'POST',
    data: {}
  });

  const handler = (res) => {
    if (res.id !== requestId) return;
    bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
    const parsed = serializer.deserializeAdd(res);
    bus.emit(constants.EVENTS.LOADING.FINISH);
    if (parsed.success) {
      bus.emit(constants.EVENTS.BLACKLIST.ADD.SUCCESS);
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        title: '✅ ID bloqué',
        body: `L'ID ${playerId} a été ajouté à la blacklist.`
      });
    } else {
      bus.emit(constants.EVENTS.BLACKLIST.ADD.ERROR, parsed);
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        title: "Echec de l'ajout",
        body: parsed.message
      });
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});

// ── RETIRER DE LA BLACKLIST ──────────────────────────────────────────────────
bus.on(constants.EVENTS.BLACKLIST.REMOVE.SUBMIT, ({ playerId, service, currency }) => {
  const requestId = `removeBlacklist-${Date.now()}`;
  bus.emit(constants.EVENTS.LOADING.START);

  const url = constants.ENDPOINTS.BLACKLIST.REMOVE
    .replace('{playerId}', playerId)
    .replace('{service}', service)
    .replace('{currency}', currency);

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'DELETE',
    data: {}
  });

  const handler = (res) => {
    if (res.id !== requestId) return;
    bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
    const parsed = serializer.deserializeRemove(res);
    bus.emit(constants.EVENTS.LOADING.FINISH);
    if (parsed.success) {
      bus.emit(constants.EVENTS.BLACKLIST.REMOVE.SUCCESS);
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        title: '🔓 ID débloqué',
        body: `L'ID ${playerId} a été retiré de la blacklist.`
      });
    } else {
      bus.emit(constants.EVENTS.BLACKLIST.REMOVE.ERROR, parsed);
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        title: 'Echec du déblocage',
        body: parsed.message
      });
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});
